import React from 'react';
import PropTypes from 'prop-types';
import { useTranslate } from 'nucleus-text';
import useBreakpoints from '@hooks/useBreakpoints';
import { injectTestId } from '@cvent/nucleus-test-automation';
import lineClamp from '@tools/lineClamp';
import FullscreenModal from '@components/layout/FullscreenModal';
import { Row } from '@cvent/carina/components/Row';
import { Col } from '@cvent/carina/components/Col';
import Button from '@cvent/carina/components/Button';

const useStyles = () => ({
  title: lineClamp(2)
});

const SwitchLoginEventModal = ({ loggedInEvent, initialEvent }) => {
  const { isMobile } = useBreakpoints();
  const { translate } = useTranslate();
  const styles = useStyles();

  const redirect = () => {
    // Force the browser to reload our app
    window.location = `/hub/events/${loggedInEvent.id}`;
  };

  return (
    <FullscreenModal
      testID="switch-event-modal"
      disableFocusTrap
      header={
        <div css={styles.title}>{translate('SwitchLoginEvent-Heading')}</div>
      }
      content={
        <p {...injectTestId('switch-event-modal-body')}>
          {translate('SwitchLoginEvent-Desc', {
            currentEventName: initialEvent.name,
            loggedInEventName: loggedInEvent.name
          })}
        </p>
      }
      footer={
        <Row justifyContent={isMobile ? 'center' : 'flex-end'}>
          <Col width="content">
            <Button
              testID="switch-event-modal-reload-button"
              text={translate('SwitchLoginEvent-Ok')}
              appearance="filled"
              onClick={redirect}
            />
          </Col>
        </Row>
      }
    />
  );
};

SwitchLoginEventModal.propTypes = {
  /** The event data being viewed on the current browser tab or window */
  loggedInEvent: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired,
  /** The details of the event that the user is currently logged into */
  initialEvent: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired
};

export default SwitchLoginEventModal;
